import { render, staticRenderFns } from "./ComprehesionCard.vue?vue&type=template&id=4de9bea7&scoped=true&"
import script from "./ComprehesionCard.vue?vue&type=script&lang=js&"
export * from "./ComprehesionCard.vue?vue&type=script&lang=js&"
import style0 from "./ComprehesionCard.vue?vue&type=style&index=0&id=4de9bea7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de9bea7",
  null
  
)

export default component.exports